module.exports = __webpack_public_path__ + "img/cartoonHead0-3.7ea37241.png";